﻿import React from 'react';
import {GridProps} from "@mui/material";
import {SearchFilterContainer} from "./styles";

const SearchFilterAndSortContainer = ({children, ...rest}: GridProps) => {
  // Three controls side by side on desktop; stacked on phones, where 24px
  // between each pushed the first result well below the fold.
  return <SearchFilterContainer container alignItems='center' gap={{ xs: 1.5, sm: 3 }} {...rest}>
    {children}
  </SearchFilterContainer>
}

export default SearchFilterAndSortContainer;
